import {
    DeleteOutlined,
    LeftOutlined,
    RetweetOutlined,
} from "@ant-design/icons";
import { Button, Flex } from "antd";
import { FC } from "react";

import { PrimaryText } from "@/components/Typography/Styled";

import { StyledMultiSelectorHeader } from "./Styled";

interface IMultiSelectorHeaderProps {
    selectedCount: number;
    allSelected: boolean;
    onSelectAllItems: () => void;
    onClearSelection: () => void;
    onExitSelectionMode: () => void;
    onMoveSelected?: () => void;
    onDeleteSelected: () => void;
}

export const MultiSelectorHeader: FC<IMultiSelectorHeaderProps> = ({
    selectedCount,
    allSelected,
    onSelectAllItems,
    onClearSelection,
    onExitSelectionMode,
    onMoveSelected,
    onDeleteSelected,
}) => {
    const isSelectionEmpty = selectedCount === 0;

    const onToggleSelectClick = () => {
        allSelected ? onClearSelection() : onSelectAllItems();
    };

    return (
        <StyledMultiSelectorHeader>
            <Flex gap={8} align="center">
                <Button
                    icon={<LeftOutlined style={{ fontSize: 18 }} />}
                    onClick={onExitSelectionMode}
                    type="text"
                />

                <PrimaryText fontSize={20} fontWeight="500">
                    {`Обрано ${selectedCount} ТТ`}
                </PrimaryText>
            </Flex>

            <Flex justify="space-between" gap={8} align="center">
                <Button
                    type="primary"
                    onClick={onToggleSelectClick}
                    style={{ paddingInline: 24 }}
                >
                    {allSelected ? "Очистити" : "Обрати всі"}
                </Button>

                <Flex gap={8}>
                    {onMoveSelected && (
                        <Button
                            icon={<RetweetOutlined style={{ fontSize: 18 }} />}
                            onClick={onMoveSelected}
                            type="text"
                            disabled={isSelectionEmpty}
                        />
                    )}

                    <Button
                        icon={<DeleteOutlined style={{ fontSize: 18 }} />}
                        onClick={onDeleteSelected}
                        type="text"
                        disabled={isSelectionEmpty}
                    />
                </Flex>
            </Flex>
        </StyledMultiSelectorHeader>
    );
};
